// Basic structure
import React, { useContext, useEffect,useState } from "react";
import { Modal, Input, Row, Col,Select, Radio } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import DirectoryContext from "../../../context/directoryManagementContext";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import ErrorMessage from "../../Forms/ErrorMessage";
import Places from "../../../Pages/gms/Places";

const AddOtherContact = ({ isOpen, isAddMode }) => {
  const directoryContext = useContext(DirectoryContext);
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const [locationData, setLocationData] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const formik = useFormik({
    // initialValues: {
    //   firstName: isAddMode ? "" : directoryContext.editData.firstName,
    //   lastName: isAddMode ? "" : directoryContext.editData.lastName,
    //   email: isAddMode ? "" : directoryContext.editData.email,
    //   phone: isAddMode ? "" : directoryContext.editData.phone
    // },
    initialValues: {
        firstName: isAddMode ? "" : directoryContext.editData.firstName,
        lastName: isAddMode ? "" : directoryContext.editData.lastName,
        position: isAddMode ? "" : directoryContext.editData.position,
        phone: isAddMode ? "" : directoryContext.editData.phone,
        email: isAddMode ? "" : directoryContext.editData.email,
        place: isAddMode ? "" : directoryContext.editData.place,
        coordinates:isAddMode ? {lat:"",lng:""} : {
          lat: directoryContext.editData?.coordinates?.lat || "",
          lng: directoryContext.editData?.coordinates?.lng || ""
        },
        address: isAddMode ? "" : directoryContext.editData.address,
        group: isAddMode ? "" : directoryContext.editData.group,
        dob: isAddMode ? "" : directoryContext.editData?.dob || "",
        isPriority:isAddMode ? false : directoryContext.editData?.dob || ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string().required("Phone is required")
    }),
    onSubmit: (values) => {
      const payload = { ...values };
      payload.place=locationData.address;
      payload.coordinates.lat=locationData.lat;
      payload.coordinates.lng=locationData.lng;
      if (isAddMode) {
        createMember.mutate(payload);
      } else {
        updateMember.mutate(payload);
      }
    }
  });

  const createMember = useMutation(
    (data) => axiosInstance.post("/api/directory/other-contacts", data),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("other-contacts");
        toast.success(res.data.message);
        closeModal();
      },
      onError: (err) => toast.error(err?.response?.data?.message || "Error")
    }
  );
  useEffect(() => {
      if (locationData?.address) {
        formik.setFieldValue("place", locationData.address);
      }
      if (locationData?.lat && locationData?.lng) {
        formik.setFieldValue("coordinates", {
          lat: locationData.lat,
          lng: locationData.lng
        });
      }
    }, [locationData]);
  const updateMember = useMutation(
    (data) =>
      axiosInstance.put(`/api/directory/other-contacts/${directoryContext.editData._id}`, data),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("other-contacts");
        toast.success(res.data.message);
        closeModal();
      },
      onError: (err) => toast.error(err?.response?.data?.message || "Error")
    }
  );

  const closeModal = () => {
    directoryContext.updateOpenModal(false);
    directoryContext.updateAddMode(true);
    formik.resetForm();
  };

  return (
    // <Modal
    //   open={isOpen}
    //   onCancel={closeModal}
    //   title={isAddMode ? "Add New Contact" : "Edit Contact"}
    //   onOk={formik.handleSubmit}
    //   okText={isAddMode ? "Add" : "Save"}
    //   destroyOnClose
    // >
      <form onSubmit={formik.handleSubmit}>
      <div className="p-6">
        <Row gutter={16}>
          <Col span={12}>
            <label>First Name</label>
            <Input name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.firstName} message={formik.errors.firstName} />
          </Col>
          <Col span={12}>
            <label>Last Name</label>
            <Input name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.lastName} message={formik.errors.lastName} />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <label>Position</label>
            <Input name="position" value={formik.values.position} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.position} message={formik.errors.position} />
          </Col>
          <Col span={12}>
            <label>Phone Number</label>
            <Input name="phone" value={formik.values.phone} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.phone} message={formik.errors.phone} />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <label>Email</label>
            <Input name="email" value={formik.values.email} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.email} message={formik.errors.email} />
          </Col>
          {/* <Col span={12}>
            <label>Location</label>
            <Input name="place" value={formik.values.place} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.place} message={formik.errors.place} />
          </Col> */}
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <label>Address</label>
            <Input name="address" value={formik.values.address} onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.address} message={formik.errors.address} />
          </Col>
        </Row>
        <Row gutter={16} className="mt-6">
          <Col span={10}>
            <label>Date of Birth</label>
            <Input name="dob" value={formik.values.dob} type="date" onChange={formik.handleChange} />
            <ErrorMessage hasError={!!formik.errors.dob} message={formik.errors.dob} />
          </Col>
          {(user?.role==='client' || user?.role==='chief_of_staff') && formik.values.dob &&
          <Col span={8}>
              <label>Priority</label>
              <Radio.Group
                name="isPriority"
                value={formik.values.isPriority}
                onChange={(e) => formik.setFieldValue("isPriority", e.target.value)}
              >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
              <ErrorMessage
                hasError={!!formik.errors.isPriority}
                message={formik.errors.isPriority}
              />
          </Col>
          }
          
        </Row>
        <Row className="mt-6" gutter={16}>
                <Col span={12} className="mb-6">
                    Location
                    <span className='required-field'>*</span>
                </Col>
                  <Places setLocationData={setLocationData} initialLocation={{
                    lat: formik.values.coordinates.lat,
                    lng: formik.values.coordinates.lng,
                    address: formik.values.place
                  }}/>
                  {/* <Places setLocationData={(value) => {
                setLocationData(value);
                formik.setFieldValue("place", value);
                }} /> */}
          </Row>
        {/* <Row gutter={16}>
          <Col span={12}>
            <label>Group</label>
            <Select
              name="group"
              value={formik.values.group}
              onChange={(value) => formik.setFieldValue("group", value)}
              options={[
                { value: "senior", label: "Senior" },
                { value: "mid", label: "Mid" },
                { value: "common", label: "Common" }
              ]}
            />
            <ErrorMessage hasError={!!formik.errors.group} message={formik.errors.group} />
          </Col>
        </Row> */}
      </div>
      
      </form>
    // </Modal>
  );
};

export default AddOtherContact;
